/**
 * Gets the Collapse Bar.
 *
 * @param {object} $container jQuery object of box container.
 * @return {object} the element
 */
function getCollapseBar( $container ) {
	return $container.find( '.doctor-collapsed-bar' );
}

/**
 * Gets the Remove Button.
 *
 * @param {object} $container jQuery object of box container.
 * @return {object} the element
 */
function getRemoveBoxButton( $container ) {
	return $container.find( '.doctor-collapsed-bar-remove-button' );
}

/**
 * Gets the Collapse Box Button.
 * @return {object} the element
 *
 * @param {object} $container jQuery object of box container.
 */
function getCollapseBoxButton( $container ) {
	return $container.find( '.doctor-collapsed-bar-collapse-button' );
}

/**
 * Gets the Add Button Container.
 *
 * @param {object} $container jQuery object of box container.
 * @return {object} the element
 */
function getAddButtonContainer( $container ) {
	return $container.find( '.gfield_list_icons' );
}

/**
 * Remove GF Add and Remove buttons and added to the container so the text "Add Doctor" can be clicked too.
 *
 * @param {object} $container jQuery object of box container.
 * @return {function} the Add Doctor event listener
 */
function removeAndGetListeners( $container ) {
	const $buttonContainer = getAddButtonContainer( $container );
	if ( !$buttonContainer.length ) {
		return;
	}

	const addButton = $buttonContainer.find( '.add_list_item ' );
	const removeButton = $buttonContainer.find( '.delete_list_item ' );
	if ( !addButton.length || !removeButton.length ) {
		return;
	}

	const addBoxClickHandler = addButton[0].onclick;
	addButton[0].onclick = false;
	removeButton[0].onclick = false;

	return addBoxClickHandler;
}

/**
 * Checks that all the box fields are not empty.
 *
 * @param {object} $container jQuery object of box container.
 * @return {boolean} true if all fields are not empty.
 */
function validateFields( $container ) {
	const $fields = $container.find( 'input' );
	let returnValue = true;

	$.each( $fields, function validate() {
		const dataLabel = $( this ).parent().attr( 'data-label' );

		if ( $( this ).val().trim() === ''
      && dataLabel !== 'Fax'
      && dataLabel !== 'Phone'
      && dataLabel !== 'Address Line 2' ) {
			returnValue = false;
		}
	});

	return returnValue;
}

/**
 * Adds the listener for the Collapses the Doctor box.
 *
 * @param {object} $container jQuery object of the Doctor container Element.
 * @param {function} addBoxClickHandler the Add click function handler.
 */
function onAddBoxListener( $container, addBoxClickHandler ) {
	const $buttonsContainer = getAddButtonContainer( $container );
	if ( !$buttonsContainer.length ) {
		return;
	}

	const $validationContainer = $buttonsContainer.find( '.validation_error' );
	$validationContainer.html( '' );

	$buttonsContainer.on( 'click', function addHandler( event ) {
		// call original GF onClick funtion
		if ( validateFields( $container ) ) {
			addBoxClickHandler.call( this, event );
		} else {
			$validationContainer.html( 'Please fill all Doctor\'s fields.' );
		}
	});
}

/**
 * Removes the box and the collaspse bar.
 *
 * @param {object} $container jQuery object of the Box.
 */
function addRemoveBoxListener( $container ) {
	const $removeBoxButton = getRemoveBoxButton( $container );
	if ( !$removeBoxButton.length ) {
		return;
	}

	$removeBoxButton.on( 'click', () => {
		$container.remove();
	});
}

/**
 * Hides the container.
 *
 * @param {object} $container jQuery object of the Doctor container
 */
function hideBox( $container ) {
	const $containerFields = $container.find( '.gfield_list_cell' );
	if ( $containerFields.length ) {
		$containerFields.addClass( 'gfield_list_cell__hide' );
	}
	const $buttonsContainer = getAddButtonContainer( $container );
	if ( $buttonsContainer.length ) {
		$buttonsContainer.hide();
	}
}

/**
 * Toggles the container.
 *
 * @param {object} $container jQuery object of the Doctor container
 */
function toggleBox( $container ) {
	const $containerFields = $container.find( '.gfield_list_cell' );
	if ( $containerFields.length ) {
		$containerFields.toggleClass( 'gfield_list_cell__hide' );
	}
	const $buttonsContainer = getAddButtonContainer( $container );
	if ( $buttonsContainer.length ) {
		$buttonsContainer.hide();
	}
}

/**
 * Collaspses and uncollapses the Box.
 *
 * @param {object} $container jQuery object of the Box.
 */
function collapseBox( $container ) {
	toggleBox( $container );

	addDoctorName( $container );

	const $collapsedBarContainer = getCollapseBar( $container );

	if ( $collapsedBarContainer.length ) {
		$collapsedBarContainer.addClass( 'doctor-collapsed-bar__show' );
		$collapsedBarContainer.toggleClass( 'doctor-collapsed-bar__expanded' );
	}
}

/**
 * Adds collapsing button listener.
 *
 * @param {object} $container jQuery object of the Box.
 */
function addCollapseBoxListener( $container ) {
	const $collapseBoxButton = getCollapseBoxButton( $container );
	if ( !$collapseBoxButton.length ) {
		return;
	}

	$collapseBoxButton.on( 'click', () => {
		collapseBox( $container );
	});
}

/**
 * Adds the Add Doctor Button Label.
 *
 * @param {object} $container jQuery object of the Doctor container
 */
function addAddButtonText( $container ) {
	const $buttonsContainer = getAddButtonContainer( $container );
	if ( !$buttonsContainer.length ) {
		return;
	}
	$buttonsContainer.append( '<span class="doctor-button-text">Add Doctor</span>' );
	$buttonsContainer.append( '<span class="validation_error"></span>' );
}

/**
 * Adds the doctor name to the collapsed bar.
 *
 * @param {object} $container jQuery object of the Doctor container
 */
function addDoctorName( $container ) {
	const $fieldRow = $container.find( '.gfield_list_cell' );
	if ( !$fieldRow.length ) {
		return;
	}
	const $firstInput = $fieldRow.first().find( 'input[type=text]' );
	const doctorName = $firstInput.length ? $firstInput.val() : '';
	const $collapseBoxButton = getCollapseBoxButton( $container );
	if ( $collapseBoxButton.length ) {
		$collapseBoxButton.html( `Doctor ${doctorName}` );
	}
}

/**
 * Adds the collapsed bar.
 *
 * @param {object} $container jQuery object of the Doctor container
 * @param {boolean} display display the collapsing bar
 */
function initCollaspedBar( $container, display ) {
	if ( display ) {
		const $collapsedBarContainer = getCollapseBar( $container );

		if ( $collapsedBarContainer.length ) {
			addDoctorName( $container );
			$collapsedBarContainer.addClass( 'doctor-collapsed-bar__show' );
			$collapsedBarContainer.addClass( 'doctor-collapsed-bar__expanded' );
		}
	}
	addRemoveBoxListener( $container );
	addCollapseBoxListener( $container );
}

/**
 * Initializes the box and collapsed bar functionalities.
 *
 * @param {object} $container jQuery object of the Doctor container.
 * @param {boolean} hidden if the box is hidden, show the collapse bar.
 */
function initBox( $container, hidden ) {
	// Add the Collapse Bar configuration.
	initCollaspedBar( $container, hidden );

	// Add "Add Doctor" Listener.
	onAddBoxListener( $container, removeAndGetListeners( $container ) );

	if ( hidden ) {
		hideBox( $container );
	}
}

/**
 * Functionnality of Doctors Add and Remove Gravity Forms (GF) List Field.
 */
export function onAddDoctor() {
	// If any Doctor Box Container is set.
	const $containers = $( '.doctors .gfield_list_group' );
	if ( !$containers.length ) {
		return;
	}

	$.each( $containers, function loop( key ) {
		const $container = $( this );
		let hideBox = true;

		if ( key === $containers.length - 1 ) {
			addAddButtonText( $container );
			// Collapse all boxes except the last one ( hidden = false ).
			hideBox = false;
		}

		initBox( $container, hideBox );
	});

	// GF filter to get the collapsed Doctor container.
	// Add collapse Bar when clicking on Add Doctor.
	// https://docs.gravityforms.com/gform_list_item_pre_add/
	gform.addFilter( 'gform_list_item_pre_add', function onAdd( $clone, $container ) {
		collapseBox( $container );
		initBox( $clone, false );
		return $clone;
	});
}
